import { useState } from 'react';

import { isAppOnPhone } from './pwa';

// Read once: turning a tablet mid-visit doesn't swap the app's shell under the person
export const useAppOnPhone = () => useState(isAppOnPhone)[0];
